import {ArticleMultilayerPlan} from '../../envisia/article/main/multilayer-plan/article-multilayer-plan.models';
import {EvListReturnType} from '../hooks/list/ev-list.models';
import {EvNavigationButtons} from '../pagination/ev-navigation-buttons';
import {MultilayerPlanListQueryForm} from './multilayer-plan.models';
import {useMultilayerPlanListQuery} from './use-multilayer-plan-list-query';
import {MultilayerPlanListRow} from './multilayer-plan-list-row';
import {EvInputField} from '../form/EvInputField';
import {useForm} from '@tanstack/react-form';
import {EvToggleSortButton} from '../form/EvToggleSortButton';
import {useListSort} from '../hooks/list/useListSort';

interface Props {
  filters: EvListReturnType<MultilayerPlanListQueryForm>;
  queryParams: MultilayerPlanListQueryForm;
  selected: ArticleMultilayerPlan | null;
}

export function MultilayerPlanList(props: Props) {
  const list = useMultilayerPlanListQuery(props.queryParams);
  const form = useForm({
    defaultValues: {
      name: props.filters.params.name,
      sort: props.filters.params.sort,
      order: props.filters.params.order,
    },
    onSubmit: () => {
    },
    listeners: {
      onChange: ({formApi}) => {
        props.filters.formChanged({...formApi.state.values});
      },
      onChangeDebounceMs: 750,
    },
  });

  const listSort = useListSort<MultilayerPlanListQueryForm>({
    form: form,
    filters: props.filters,
  });

  return <>
    <div className="min-h-dvh-80">
      <div className="grid grid-cols-20-65-5-5-5">
        <form.Subscribe selector={a => [a.values.sort, a.values.order]}>
          {([sort, order]) =>
            <div className="grid col-span-5 grid-cols-subgrid">
              <div className="p-2 text-right">
                <EvToggleSortButton sortKey="id"
                                    title="Nach Nr. sortieren"
                                    sort={sort}
                                    order={order}
                                    listSort={listSort}>
                  Nr.
                </EvToggleSortButton>
              </div>
              <div className="p-2">
                <EvToggleSortButton sortKey="name"
                                    title="Nach Bezeichnung sortieren"
                                    sort={sort}
                                    order={order}
                                    listSort={listSort}>
                  Bezeichnung
                </EvToggleSortButton>
              </div>
              <div className="col-span-3"/>
            </div>
          }
        </form.Subscribe>
        <form className="grid col-span-5 grid-cols-subgrid
                         bg-storz-whitetable-background
                         border border-solid border-storz-whitetable-border border-b-0"
              onSubmit={async (e) => {
                e.preventDefault();
                await form.handleSubmit();
              }}>
          <div className="p-2">
          </div>
          <div className="p-2">
            <form.Field name="name">
              {field =>
                <EvInputField type="text" formStyle="sm" title="Nach Bezeichnung suchen" field={field}/>
              }
            </form.Field>
          </div>
          <div className="col-span-3"/>
        </form>
      </div>

      <div className="grid grid-cols-20-65-5-5-5">
        {
          list.objects.map(plan =>
            <MultilayerPlanListRow key={plan.id}
                                   plan={plan}
                                   selected={props.selected?.shared_id === plan.shared_id}
                                   select={(id) =>
                                     props.filters.formChanged({shared_id: id ?? null}, {keepPage: true})}/>)
        }
      </div>
    </div>

    <EvNavigationButtons page={(props.filters.params.page ?? 1)}
                         pagesTotal={list.pages}
                         setPage={props.filters.pageChanged}/>
  </>;
}
